// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var ToppingId = function (x) {
    return x;
};
var SideId = function (x) {
    return x;
};
var SideDishId = function (x) {
    return x;
};
var PizzaSize = function (x) {
    return x;
};
var PizzaId = function (x) {
    return x;
};
var PanType = function (x) {
    return x;
};
var DrinkSize = function (x) {
    return x;
};
var DrinkId = function (x) {
    return x;
};
var DishId = function (x) {
    return x;
};
var DishGroupId = function (x) {
    return x;
};
var udecodePizzaSize = Unscramble.decodeInt1;
var udecodePizzaId = Unscramble.decodeInt1;
var udecodePanType = Unscramble.decodeInt1;
var udecodeForeignToppingId = Unscramble.decodeInt1;
var udecodeForeignSideId = Unscramble.decodeInt1;
var udecodeForeignSideDishId = Unscramble.decodeInt1;
var udecodeForeignDishGroupId = Unscramble.decodeInt1;
var udecodeDrinkSize = Unscramble.decodeInt1;
var udecodeDrinkId = Unscramble.decodeInt1;
var udecodeDishId = Unscramble.decodeInt1;
var showToppingId = Data_Show.showInt;
var showSideId = Data_Show.showInt;
var showSideDishId = Data_Show.showInt;
var showPizzaSize = Data_Show.showInt;
var showPizzaId = Data_Show.showInt;
var showPanType = Data_Show.showInt;
var showDrinkSize = Data_Show.showInt;
var showDrinkId = Data_Show.showInt;
var showDishId = Data_Show.showInt;
var showDishGroupId = Data_Show.showInt;
var ordToppingId = Data_Ord.ordInt;
var ordSideId = Data_Ord.ordInt;
var ordSideDishId = Data_Ord.ordInt;
var ordPizzaSize = Data_Ord.ordInt;
var ordPizzaId = Data_Ord.ordInt;
var ordPanType = Data_Ord.ordInt;
var ordDrinkSize = Data_Ord.ordInt;
var ordDrinkId = Data_Ord.ordInt;
var ordDishId = Data_Ord.ordInt;
var ordDishGroupId = Data_Ord.ordInt;
var newtypeToppingId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeSideId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeSideDishId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypePizzaSize = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypePizzaId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypePanType = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeDrinkSize = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeDrinkId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeDishId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeDishGroupId = {
    Coercible0: function () {
        return undefined;
    }
};
var fromJSONKeyForeignSideId = /* #__PURE__ */ (function () {
    return {
        fromJSONKey: new Unscramble.FromJSONKeyString(function (s) {
            var v = Data_Int.fromString(s);
            if (v instanceof Data_Maybe.Just) {
                return v.value0;
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Unscramble.decodingError("invalid Int key");
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.Types.Id (line 73, column 5 - line 75, column 51): " + [ v.constructor.name ]);
        })
    };
})();
var eqToppingId = Data_Eq.eqInt;
var eqSideId = Data_Eq.eqInt;
var eqSideDishId = Data_Eq.eqInt;
var eqPizzaSize = Data_Eq.eqInt;
var eqPizzaId = Data_Eq.eqInt;
var eqPanType = Data_Eq.eqInt;
var eqDrinkSize = Data_Eq.eqInt;
var eqDrinkId = Data_Eq.eqInt;
var eqDishId = Data_Eq.eqInt;
var eqDishGroupId = Data_Eq.eqInt;
var encodePizzaSize = Foreign_Generic_Class.intEncode;
var encodePizzaId = Foreign_Generic_Class.intEncode;
var encodePanType = Foreign_Generic_Class.intEncode;
var encodeForeignToppingId = Foreign_Generic_Class.intEncode;
var encodeForeignSideId = Foreign_Generic_Class.intEncode;
var encodeForeignSideDishId = Foreign_Generic_Class.intEncode;
var encodeForeignDishGroupId = Foreign_Generic_Class.intEncode;
var encodeDrinkSize = Foreign_Generic_Class.intEncode;
var encodeDrinkId = Foreign_Generic_Class.intEncode;
var encodeDishId = Foreign_Generic_Class.intEncode;
var decodePizzaSize = Foreign_Generic_Class.intDecode;
var decodePizzaId = Foreign_Generic_Class.intDecode;
var decodePanType = Foreign_Generic_Class.intDecode;
var decodeForeignToppingId = Foreign_Generic_Class.intDecode;
var decodeForeignSideId = Foreign_Generic_Class.intDecode;
var decodeForeignSideDishId = Foreign_Generic_Class.intDecode;
var decodeForeignDishGroupId = Foreign_Generic_Class.intDecode;
var decodeDrinkSize = Foreign_Generic_Class.intDecode;
var decodeDrinkId = Foreign_Generic_Class.intDecode;
var decodeDishId = Foreign_Generic_Class.intDecode;
var asJsonKeySideId = /* #__PURE__ */ (function () {
    return {
        asJSONKey: new Data_Map_Serialized.AsJSONKeyString(Data_Show.show(showSideId), function (s) {
            var v = Data_Int.fromString(s);
            if (v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError("invalid Int key"));
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.Types.Id (line 79, column 5 - line 81, column 59): " + [ v.constructor.name ]);
        })
    };
})();
export {
    PizzaId,
    ToppingId,
    DishId,
    SideId,
    SideDishId,
    DishGroupId,
    PanType,
    DrinkId,
    PizzaSize,
    DrinkSize,
    newtypePizzaId,
    eqPizzaId,
    ordPizzaId,
    showPizzaId,
    decodePizzaId,
    udecodePizzaId,
    encodePizzaId,
    newtypeToppingId,
    eqToppingId,
    ordToppingId,
    showToppingId,
    decodeForeignToppingId,
    udecodeForeignToppingId,
    encodeForeignToppingId,
    newtypeDishId,
    eqDishId,
    ordDishId,
    showDishId,
    decodeDishId,
    udecodeDishId,
    encodeDishId,
    newtypeSideDishId,
    eqSideDishId,
    ordSideDishId,
    showSideDishId,
    decodeForeignSideDishId,
    udecodeForeignSideDishId,
    encodeForeignSideDishId,
    newtypeSideId,
    eqSideId,
    ordSideId,
    showSideId,
    decodeForeignSideId,
    udecodeForeignSideId,
    encodeForeignSideId,
    fromJSONKeyForeignSideId,
    asJsonKeySideId,
    newtypeDishGroupId,
    eqDishGroupId,
    ordDishGroupId,
    showDishGroupId,
    decodeForeignDishGroupId,
    udecodeForeignDishGroupId,
    encodeForeignDishGroupId,
    newtypePanType,
    decodePanType,
    udecodePanType,
    encodePanType,
    eqPanType,
    ordPanType,
    showPanType,
    newtypeDrinkId,
    decodeDrinkId,
    udecodeDrinkId,
    encodeDrinkId,
    eqDrinkId,
    ordDrinkId,
    showDrinkId,
    newtypeDrinkSize,
    decodeDrinkSize,
    udecodeDrinkSize,
    encodeDrinkSize,
    eqDrinkSize,
    ordDrinkSize,
    showDrinkSize,
    newtypePizzaSize,
    decodePizzaSize,
    udecodePizzaSize,
    encodePizzaSize,
    eqPizzaSize,
    ordPizzaSize,
    showPizzaSize
};
//# sourceMappingURL=index.js.map
